import { reloadGoogleMap } from 'assets/utils/reloadGoogleMap';
import { useFilter } from 'components/context/FilterContext';
import Link from 'next/link';
import React, { useEffect } from 'react';

type LocationSearchProps = {
	name: string;
};

const LocationSearch = (props: LocationSearchProps): JSX.Element => {
	const { name } = props;
	const { setFilterState } = useFilter();
	const { filterState } = useFilter();

	const setLatLng = (result: any, latLng: any) => {
		let zipObj = result.address_components.find((x: any) => x.types[0] === 'postal_code'),
			zipCode = zipObj && zipObj.short_name;

		setFilterState((prevState) => ({
			...prevState,
			userLocation: {
				...prevState.userLocation,
				latitude: latLng.lat,
				longitude: latLng.lng,
			},
		}));

		if (zipCode) {
			//setLocationFilter();
		} else {
			reverseGeocode(latLng);
		}
	};

	const buildAddress = (result: any, latLng: any) => {
		let zipObj = result.address_components.find((x: any) => x.types[0] === 'postal_code'),
			zipCode = zipObj && zipObj.short_name,
			localityObj = result.address_components.find((x: any) => x.types[0] === 'locality'),
			localityName = localityObj && localityObj.short_name,
			stateObj = result.address_components.find(
				(x: any) => x.types[0] === 'administrative_area_level_1'
			),
			stateName = stateObj && stateObj.short_name;

		setFilterState((prevState) => ({
			...prevState,
			userLocation: {
				...prevState.userLocation,
				location: `${localityName ? localityName + ', ' : ''}${stateName ? stateName + ' ' : ''}${
					zipCode ? zipCode : ''
				}`,
			},
		}));

		if (latLng) {
			setLatLng(result, latLng);
		}
	};

	const reverseGeocode = (latLng: any) => {
		const geocoder = new google.maps.Geocoder();

		geocoder.geocode({ location: latLng }, function (results, status) {
			if (status == 'OK') {
				setFilterState((prevState) => ({
					...prevState,
					userLocation: {
						...prevState.userLocation,
						geolocating: false,
					},
				}));

				if (results[0]) {
					buildAddress(results[0], latLng);
				} else {
					console.log('No results found');
				}
			} else {
				console.log('Geocoder failed due to: ' + status);

				setFilterState((prevState) => ({
					...prevState,
					userLocation: {
						...prevState.userLocation,
						geolocating: false,
					},
				}));
			}
		});
	};

	const geolocate = () => {
		setFilterState((prevState) => ({
			...prevState,
			userLocation: {
				...prevState.userLocation,
				geolocating: true,
			},
		}));
		navigator.geolocation.getCurrentPosition(
			(position) => {
				if (position && position.coords && position.coords.latitude && position.coords.longitude) {
					let latLng = {
						lat: position.coords.latitude,
						lng: position.coords.longitude,
					};

					reverseGeocode(latLng);
				}
			},
			(err) => {
				setFilterState((prevState) => ({
					...prevState,
					userLocation: {
						...prevState.userLocation,
						geolocating: false,
					},
				}));
				console.log('Geocoding failed with ' + err);
			}
		);
	};

	useEffect(() => {
		if (!window?.google?.maps) {
			reloadGoogleMap(
				'https://maps.googleapis.com/maps/api/js?key=AIzaSyAjtlB7VsJ0SmtNzMGXyw0_EmSXQvd6qBk&libraries=places&sensor=false&loading=async'
			);
		}
	}, []);

	return (
		<div>
			LOCATION SEARCH COMPONENTS {name}
			<button onClick={() => geolocate()}>LOCATE ME</button>
			<Link href="locations/osf-saint-anthonys-diagnostic-imaging-alton-120060">test</Link>
			{filterState?.userLocation?.geolocating && <h1>GEOLOCATING</h1>}
		</div>
	);
};

export default LocationSearch;
